import { DefinedUserPermissions } from '@workinance/shared/data/permissions';
import { type INavigationItem } from '@workinance/shared/ui/AppShellLayoutComponent';
import {
	CustomersIcon,
	DashboardIcon,
	InventoryIcon,
	PurchaseOrderIcon,
	ReceiptIcon,
	SalesIcon,
	SettingsIcon,
	TeamIcon,
} from '@workinance/shared/ui/icons';

export const primaryNavigation: INavigationItem[] = [
	// No `requiredPermissions`: every signed-in person has their own dashboard.
	{ label: 'Dashboard', to: '/dashboard', icon: DashboardIcon },
	{
		label: 'CRM',
		icon: CustomersIcon,
		children: [
			{
				label: 'Customers',
				to: '/crm/customers',
				requiredPermissions: [DefinedUserPermissions.customer.view],
			},
			{
				label: 'Surveys',
				to: '/crm/surveys',
				requiredPermissions: [DefinedUserPermissions.survey.view],
			},
		],
	},
	{
		label: 'Inventory',
		icon: InventoryIcon,
		children: [
			{
				label: 'Products',
				to: '/inventory/products',
				requiredPermissions: [DefinedUserPermissions.product.view],
			},
			{
				label: 'Categories',
				to: '/inventory/categories',
				requiredPermissions: [DefinedUserPermissions.productCategory.view],
			},
		],
	},
	{
		label: 'Sales',
		to: '/sales',
		icon: ReceiptIcon,
		requiredPermissions: [DefinedUserPermissions.sale.view],
	},
	{
		label: 'POS',
		to: '/pos',
		icon: SalesIcon,
		requiredPermissions: [DefinedUserPermissions.sale.add],
	},
	{
		label: 'Procurement',
		icon: PurchaseOrderIcon,
		children: [
			{
				label: 'Purchase orders',
				to: '/procurement/orders',
				requiredPermissions: [DefinedUserPermissions.purchaseOrder.view],
			},
			{
				label: 'Suppliers',
				to: '/procurement/suppliers',
				requiredPermissions: [DefinedUserPermissions.supplier.view],
			},
		],
	},
];

/** Running the team: shown to owners, and to team members whose roles let them see users or roles. */
export const usersNavigationItem: INavigationItem = {
	label: 'Users',
	to: '/users',
	icon: TeamIcon,
	requiredPermissions: [DefinedUserPermissions.user.view],
};

export const rolesNavigationItem: INavigationItem = {
	label: 'Roles',
	to: '/roles',
	icon: SettingsIcon,
	requiredPermissions: [DefinedUserPermissions.role.view],
};

export const valueListsNavigationItem: INavigationItem = {
	label: 'Value lists',
	to: '/value-lists',
	icon: SettingsIcon,
	requiredPermissions: [DefinedUserPermissions.valueList.view],
};
